import { React } from '@gasbuddy/react';
import { Dimmer, Loader, Button, Segment, Form, Message, Input, TextArea } from 'semantic-ui-react';
import { fetchApi } from '@gasbuddy/react/build/fetchApi';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';

export class Wex extends React.Component {
  state = {
  }

  recordPayment = (e) => {
    e.preventDefault();
    const { batch, bankRef, amount } = this.state;
    this.setState({ saving: true }, async () => {
      try {
        const { status, body: error } = await fetchApi({
          url: '/payments/wex/record-payment',
          body: {
            batch,
            bankRef,
            amount: amount.trim().replace(/,/g, ''),
          },
        });
        if (status !== 200) {
          this.setState({ saving: false, payError: JSON.stringify(error, null, '\t') });
          return;
        }
        this.setState({ saving: false, payError: null, batch: null, amount: null, bankRef: null });
      } catch (payError) {
        this.setState({ saving: false, payError });
      }
    });
  }

  submitWex = (e) => {
    e.preventDefault();
    const { wexJson, forceTransactionId } = this.state;
    this.setState({ saving: true }, async () => {
      try {
        const { status, body: error } = await fetchApi({
          url: '/payments/wex/submit-tx',
          body: {
            transaction: wexJson,
            force_match_transaction_id: forceTransactionId,
          },
        });
        if (status !== 200) {
          this.setState({ saving: false, txId: null, payError: JSON.stringify(error, null, '\t') });
          return;
        }
        this.setState({ saving: false, payError: null, wexJson: null, forceTransactionId: null, txId: error.transaction_id });
      } catch (payError) {
        this.setState({ saving: false, payError, txId: null });
      }
    });
  }

  render() {
    const { saving, payError, batch, bankRef, amount, forceTransactionId, wexJson, txId } = this.state;

    return (
      <Auth forRoles={[Role.Superuser, Role.PaymentReconciliation]}>
        <Nav>
          <div>
            <h1>Wex Reconciliation</h1>
            <Dimmer.Dimmable as={Segment} dimmed={saving}>
              <Dimmer active={saving}>
                <Loader />
              </Dimmer>
              <div>
                <Segment>
                  <h2>Enter Wex Payment</h2>
                  <Form error={!!payError}>
                    <Message error>
                      Unable to record Wex payment.
                      <pre>{payError}</pre>
                    </Message>
                    <Form.Group widths="equal">
                      <Form.Input
                        defaultValue={batch}
                        iconPosition="left"
                        icon="calendar"
                        label="Wex Batch"
                        placeholder="YYYYMMDD"
                        onChange={(e, { value }) => this.setState({ batch: value })}
                      />
                      <Form.Input
                        defaultValue={bankRef}
                        label="Bank Reference Number"
                        placeholder="Usually 4-6 digits"
                        onChange={(e, { value }) => this.setState({ bankRef: value })}
                      />
                      <Form.Input
                        defaultValue={amount}
                        iconPosition="left"
                        icon="dollar"
                        label="Payment Amount"
                        placeholder="1234567.89"
                        onChange={(e, { value }) => this.setState({ amount: value })}
                      />
                    </Form.Group>
                    <Button onClick={this.recordPayment}>Record Payment</Button>
                  </Form>
                </Segment>
                <Segment>
                  <h2>Import Failed Batch Transaction</h2>
                  {txId && (
                    <Message>
                      <a href={`/payments/transaction/${txId}`}>{txId}</a>
                    </Message>
                  )}
                  <Form>
                    <Input
                      fluid
                      label="Force Match to TransactionId"
                      defaultValue={forceTransactionId}
                      onChange={(e, { value }) => this.setState({ forceTransactionId: value })}
                      placeholder="Leave Blank for Auto-Matching"
                    />
                    <br />
                    <TextArea
                      fluid
                      label="Wex Batch File Transaction JSON"
                      defaultValue={wexJson}
                      onChange={(e, { value }) => this.setState({ wexJson: value })}
                      placeholder="Paste JSON from failure queue"
                    />
                    <br />
                    <br />
                    <Button negative onClick={this.submitWex}>Submit Transaction</Button>
                  </Form>
                </Segment>
              </div>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}
